import TagStore from "../store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('setIsFocusedTag',
    function setIsFocusedTag(tagId: string) {
        TagStore().focusedTagId = tagId;
});
